/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerAdmissionFlags200ResponseDataInner } from './FindAllScreenerAdmissionFlags200ResponseDataInner';
import {
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSONTyped,
} from './FindAllScreenerAdmissionFlags200ResponseDataInner';

/**
 * 
 * @export
 * @interface UpdateScreenerLeadAdmissionFlagRequest
 */
export interface UpdateScreenerLeadAdmissionFlagRequest {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    flag_id?: string;
    /**
     * 
     */
    is_dismissed?: boolean;
    /**
     * 
     */
    admission_flag?: FindAllScreenerAdmissionFlags200ResponseDataInner;
}

/**
 * Check if a given object implements the UpdateScreenerLeadAdmissionFlagRequest interface.
 */
export function instanceOfUpdateScreenerLeadAdmissionFlagRequest(value: object): value is UpdateScreenerLeadAdmissionFlagRequest {
    return true;
}

export function UpdateScreenerLeadAdmissionFlagRequestFromJSON(json: any): UpdateScreenerLeadAdmissionFlagRequest {
    return UpdateScreenerLeadAdmissionFlagRequestFromJSONTyped(json, false);
}

export function UpdateScreenerLeadAdmissionFlagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScreenerLeadAdmissionFlagRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'flag_id': json['flag_id'] == null ? undefined : json['flag_id'],
        'is_dismissed': json['is_dismissed'] == null ? undefined : json['is_dismissed'],
        'admission_flag': json['admission_flag'] == null ? undefined : FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON(json['admission_flag']),
    };
}

export function UpdateScreenerLeadAdmissionFlagRequestToJSON(json: any): UpdateScreenerLeadAdmissionFlagRequest {
    return UpdateScreenerLeadAdmissionFlagRequestToJSONTyped(json, false);
}

export function UpdateScreenerLeadAdmissionFlagRequestToJSONTyped(value?: UpdateScreenerLeadAdmissionFlagRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'flag_id': value['flag_id'],
        'is_dismissed': value['is_dismissed'],
        'admission_flag': FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(value['admission_flag']),
    };
}

